import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({
  name: 'dateTimeFormat'
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(value: string, format: string = 'medium'): string {
    if (!value) return value;

    const date = new Date(value);
    return formatDate(date, format, 'en-US');
  }
}
